import React, { Component } from 'react'

class downloadLogModal extends Component {
    constructor(props) {
        super(props)
        this.modalId = `${this.props.triggerId.replace('Trigger', '')}Container`
    }

    componentDidMount() {
        if (typeof _satellite !== 'undefined')
            window._satellite.track('cbTrack.viewInDom')

        const triggerElement = document.getElementById(this.props.triggerId)
        if (triggerElement) {
            window.cb.apricot.CBModal.init({
                elem: triggerElement,
                targetElem: this.modalId,
            })
        }
    }


    render() {
        return (
            <div className="downloadLogModal">
                <div id={this.modalId} className="cb-modal" aria-hidden="true">
                    <div className="cb-modal-overlay" tabIndex="-1" data-cb-modal-close>
                        <div className="cb-modal-container" role="dialog" aria-modal="true"
                             aria-labelledby={`${this.modalId}Title`}>
                            <div className="cb-modal-header cb-modal-has-close">
                                <h2 className="cb-modal-title" id={`${this.modalId}Title`}>Your log file is being
                                    generated.</h2>
                                <button type="button" className="cb-btn cb-btn-square cb-btn-greyscale cb-btn-close"
                                        aria-describedby={`${this.modalId}Title`} data-cb-modal-close>
                                    <span className="cb-glyph cb-x-mark" aria-hidden="true"></span>
                                    <span className="sr-only">Close</span>
                                </button>
                            </div>
                            <div className="cb-modal-content">
                                <p>Please come back in a few minutes and refresh the page to download your file.</p>
                            </div>
                            <div className="cb-modal-footer">
                                <div className="cb-btn-row">
                                    <button type="button" className="btn btn-primary btn-sm" data-cb-modal-close>OK
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default downloadLogModal